module.exports = __webpack_public_path__ + "img/category_main_205.442e08bf.jpg";